import { render, staticRenderFns } from "./Choose.vue?vue&type=template&id=2f0a4eae&scoped=true"
import script from "./Choose.vue?vue&type=script&lang=js"
export * from "./Choose.vue?vue&type=script&lang=js"
import style0 from "./Choose.vue?vue&type=style&index=0&id=2f0a4eae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f0a4eae",
  null
  
)

export default component.exports